import { useTranslation } from 'react-i18next';

const Otros = () => {
    const { t } = useTranslation();

    return (

        <div className="o-cont-fullw mb-80">
            <div className="container">
                <h2 className="text-center h1">Otros hoteles sugeridos</h2>
                <hotel-detail-swipper-hotel-related >
                    <div init="false" className="c-swiper-hotels" style={{ display: "flex" }}>
                        <div style={{ width: "410.667px", marginRight: "16px" }} role="group" aria-label="1 / 3" className="flexrelated">
                            <div className="c-card-hotel">
                                <figure className="c-card-hotel_img">
                                    <img src="https://pro-static.h10hotels.com/gallery/T2D3/00.1_HCBLobby1.jpg" alt="Lobby" />
                                </figure>
                                <div className="c-card-hotel_body">
                                    <h3 className="text-uppercase">H10 Casanova</h3>
                                    <div className="o-stars">
                                        <i className="fa-solid fa-star text-categoria"></i>
                                        <i className="fa-solid fa-star text-categoria"></i>
                                        <i className="fa-solid fa-star text-categoria"></i>
                                        <i className="fa-solid fa-star text-categoria"></i>
                                        <i className="fa-solid fa-star text-categoria"></i>
                                    </div>
                                    <ul className="o-list-tags">
                                        <li>Terraza Rooftop</li>
                                        <li>Centro de la ciudad</li>
                                        <li>Negocios</li>
                                        <li>Spa</li>
                                    </ul>
                                    <p className="mb-4">
                                        <span className="o-icon">
                                            <i className="fa-solid fa-location-dot"></i>
                                        </span> Barcelona
                                    </p>
                                    <a className="btn btn-primary" href="/es/hoteles-barcelona/h10-casanova/reserva">Ver disponibilidad</a>
                                </div>
                            </div>
                        </div>
                        <div style={{ width: "410.667px", marginRight: "16px" }} role="group" aria-label="2 / 3" className="flexrelated">
                            <div className="c-card-hotel">
                                <figure className="c-card-hotel_img">
                                    <img src="https://pro-static.h10hotels.com/gallery/T2D3/01_HUTwentyOneTerrace.jpg" alt="Terraza Twenty One, con vistas a la ciudad" />
                                </figure>
                                <div className="c-card-hotel_body">
                                    <h3 className="text-uppercase">H10 Universitat</h3>
                                    <div className="o-stars">
                                        <span className="o-icon text-categoria">
                                            <i className="fa-solid fa-star"></i>
                                        </span>
                                        <span className="o-icon text-categoria">
                                            <i className="fa-solid fa-star"></i>
                                        </span>
                                        <span className="o-icon text-categoria">
                                            <i className="fa-solid fa-star"></i>
                                        </span>
                                        <span className="o-icon text-categoria">
                                            <i className="fa-solid fa-star"></i>
                                        </span>
                                    </div>
                                    <ul className="o-list-tags">
                                        <li>Terraza Rooftop</li>
                                        <li>Centro de la ciudad</li>
                                    </ul>
                                    <p className="mb-4">
                                        <span className="o-icon">
                                            <i className="fa-solid fa-location-dot"></i>
                                        </span> Barcelona
                                    </p>
                                    <a className="btn btn-primary" href="/es/hoteles-barcelona/h10-universitat/reserva">Ver disponibilidad</a>
                                </div>
                            </div>
                        </div>
                        <div style={{ width: "410.667px", marginRight: "16px" }} role="group" aria-label="3 / 3" className="flexrelated">
                            <div className="c-card-hotel">
                                <figure className="c-card-hotel_img">
                                    <img src="https://pro-static.h10hotels.com/gallery/T2D3/03_HMBLobby.jpg" alt="Lobby" />
                                </figure>
                                <div className="c-card-hotel_body">
                                    <h3 className="text-uppercase">H10 Marina Barcelona</h3>
                                    <div className="o-stars">
                                        <span className="o-icon text-categoria">
                                            <i className="fa-solid fa-star"></i>
                                        </span>
                                        <span className="o-icon text-categoria">
                                            <i className="fa-solid fa-star"></i>
                                        </span>
                                        <span className="o-icon text-categoria">
                                            <i className="fa-solid fa-star"></i>
                                        </span>
                                        <span className="o-icon text-categoria">
                                            <i className="fa-solid fa-star"></i>
                                        </span>
                                    </div>
                                    <ul className="o-list-tags">
                                        <li>Gastronomía de autor</li>
                                        <li>Terraza Rooftop</li>
                                        <li>Junto al mar</li>
                                        <li>Spa</li>
                                    </ul>
                                    <p className="mb-4">
                                        <span className="o-icon">
                                            <i className="fa-solid fa-location-dot"></i>
                                        </span> Barcelona
                                    </p>
                                    <a className="btn btn-primary" href="/es/hoteles-barcelona/h10-marina-barcelona/reserva">Ver disponibilidad</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </hotel-detail-swipper-hotel-related>
            </div>
        </div>
    );
};

export default Otros;
